export default __webpack_public_path__ + "static/media/List-documentation.0fb639c9.md";